import { routeName } from '@/constants/routeName';
import { parseQueryToken, hubSelectorDisabler, } from '@/router-middleware';
import LocationControl from '@/views/Dialog/LocationControl/index.vue';
export default {
    // 출발 도착 관제
    path: '/location-control',
    name: routeName.LOCATION_CONTROL,
    component: LocationControl,
    meta: {
        middleware: [
            hubSelectorDisabler,
            parseQueryToken,
        ],
    },
};
